<script setup>
import { computed } from '#imports';

const props = defineProps({
  crewMember: {
    type: Object,
    required: true,
  },
  withAvatar: {
    type: Boolean,
    default: false,
  },
  isLight: {
    type: Boolean,
    default: false,
  },
});

const specialityName = computed(() =>
  props.crewMember.staff.sex === 'male'
    ? props.crewMember.speciality.nameMale
    : props.crewMember.speciality.nameFemale
);

const classes = computed(() => ({
  'member--with-avatar': props.withAvatar,
  'member--light': props.isLight,
}));
</script>

<template>
  <div class="member" :class="classes">
    <div class="member__speciality-name">
      {{ specialityName }}
    </div>
    <div class="member__inner">
      <div v-if="withAvatar" class="member__avatar">
        <BaseAvatar size="big" :image="crewMember.staff.image" />
      </div>
      <div class="member__name-wrap">
        <div class="member__speciality-name member__speciality-name--mobile">
          {{ specialityName }}
        </div>
        <div class="member__name" :title="crewMember.staff.name">
          <span>
            {{ crewMember.staff.name }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="postcss" scoped>
.member {
  transition: var(--default-transition) opacity;

  &__speciality-name {
    font-size: 14px;
    line-height: 22px;
    color: rgba(var(--black-color--rgb), 40%);

    &--mobile {
      display: none;
    }
  }

  &__inner {
    display: flex;
    align-items: center;
  }

  &__avatar {
    margin-right: 4px;
  }

  &__name {
    max-width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 18px;
    line-height: 22px;
    color: var(--accent-color);

    span {
      padding: 0 4px;
      background-color: #f2e6f1;
      box-decoration-break: clone;
      border-radius: 4px;
    }
  }

  &:hover {
    opacity: 0.6;
  }

  &--with-avatar {
    .member__name {
      font-size: var(--h6-font-size);
      line-height: var(--h6-line-height);
      font-weight: 700;
      width: min-content;
      min-width: 162px;

      & > span {
        word-spacing: 100vw;

        @media (--tablet-vp) {
          word-spacing: unset;
        }
      }
    }
  }

  .member__name-wrap {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &--light {
    .member__speciality-name {
      color: rgba(var(--white-color--rgb), 40%);
    }

    .member__name {
      color: var(--white-color);

      span {
        background-color: rgba(248, 249, 250, 20%);
      }
    }
  }

  @media (--small-vp) {
    &__speciality-name {
      display: none;

      &--mobile {
        display: block;
        font-size: 12px;
        line-height: 15px;
      }
    }

    &__name {
      font-size: 14px;
      line-height: 18px;
    }

    &--with-avatar {
      .member__name-wrap {
        width: auto;
      }

      .member__name {
        font-size: 14px;
        line-height: 18px;
        width: auto;
        min-width: auto;
      }
    }
  }
}
</style>
